module.exports = __webpack_public_path__ + "media/images/linkedin-14fff9813b44788757e28e45a2f8d647.png";